import Vue from 'vue';
import Component from 'vue-class-component';
import {
    ILoyaltySubscriptionType,
    ILoyaltySubscriptionTypeListItem,
} from '@/entity/loyalty/loyaltySubscription/loyaltySubscriptionType/LoyaltySubscriptionType.types';

import { LoyaltySubscriptionTypeStore } from '@/store/modules/Loyalty/Subscription/LoyaltySubscriptionType';

@Component
export class SubscriptionTypeMix extends Vue {
    get loyaltySubscriptionTypes(): ILoyaltySubscriptionType | null {
        return LoyaltySubscriptionTypeStore.loyaltySubscriptionTypes;
    }
    get loyaltySubscriptionType(): ILoyaltySubscriptionTypeListItem | null {
        return LoyaltySubscriptionTypeStore.loyaltySubscriptionType;
    }
}
